// extracted by mini-css-extract-plugin
export default {"issueBtn":"IssueButton_issueBtn__faoxQ"};